// extracted by css-extract-rspack-plugin
export default {"content":"SlideTransition_content__qNrvH","root":"SlideTransition_root__R4ggP","push":"SlideTransition_push__rxFo9","pop":"SlideTransition_pop__-UAQ8"};